import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import Tier from '../../components/buy-flow/tier-selector';
import CybersourcePaymentPage from '../../components/cybersource-payment';
import PageNotFound from '../../components/page-not-found';
import Start from '../../components/signup/start';
import Success from '../../components/signup/success';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { checkIsAuthenticated } from '../../lib/helpers';
import { isFormIncomplete } from '../../lib/shared-signup';
import { getConnectors, getMarketingDataFromUrl, getSignupPartnerParams } from '../../lib/side-effects';
import { selectState } from '../../selectors';
import { toggleIsSoho } from '../../store/avatax-signup';
import { setActiveFlow } from '../../store/system';
import SelectConnectorContainer from './select-connector';
import Setup from './setup';

const Signup = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const {
    sharedSignup,
    avataxSignup: { partnerSignup },
  } = useSelector(selectState);
  const incompleteSignupForm = isFormIncomplete(sharedSignup);

  // NOTE(Sasha): 3DCart has been renamed to Shift4Shop. To maintain old links
  // we redirect the partner param to use shift4shop.
  const redirectToShift4Shop = /3dcart/i.test(location.search);

  useEffect(() => {
    if (checkIsAuthenticated()) return;

    dispatch(getConnectors());
    dispatch(setActiveFlow('avatax-direct-buy'));
  }, []);

  useEffect(() => {
    if (checkIsAuthenticated()) return;

    dispatch(getSignupPartnerParams(location.search));
    dispatch(getMarketingDataFromUrl());
    dispatch(toggleIsSoho(location.search));
  }, [location.search]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (checkIsAuthenticated()) return;

    dispatch(getMarketingDataFromUrl());
  }, [partnerSignup?.code]);

  if (redirectToShift4Shop) {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('partner', 'shift4shop');
    return <Redirect to={{ pathname: location.pathname, search: searchParams.toString() }} />;
  }

  return (
    <Switch>
      <Route exact path='/buy' component={Start} />
      <Route path='/buy/company' component={Setup} />
      <Route path='/buy/connector'>
        {incompleteSignupForm ? (
          <Redirect to={{ pathname: '/buy', search: location.search }} />
        ) : (
          <Route path='/buy/connector' component={SelectConnectorContainer} />
        )}
      </Route>
      <Route path='/buy/success' component={Success} />
      <Route exact path='/buy/buy' component={Tier} />
      <Route exact path='/buy/buy/payment'>
        <CybersourcePaymentPage paymentView='default' />
      </Route>
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default Signup;
